// No-js Check
var jsFlag = document.getElementsByTagName('html');
if (jsFlag[0].classList.contains('no-js')) {
    jsFlag[0].classList.remove('no-js');
    jsFlag[0].classList.add('js')
}